import { styled } from "@linaria/react";
import { css } from "@linaria/core";
import Button from "../button";
import { useState } from "react";
const StyledForm = /*#__PURE__*/styled("form")({
  name: "StyledForm",
  class: "smvobak"
});
const StyledInput = /*#__PURE__*/styled("input")({
  name: "StyledInput",
  class: "s1oc94i5"
});
const buttonStyling = "b1erzk6u";
type Props = {
  extended?: boolean;
  selectedDepartments?: Department[];
};
export default function JobsForm({
  extended = false,
  selectedDepartments = []
}: Props): JSX.Element {
  const [value, setValue] = useState("");
  return <StyledForm onSubmit={event => event.preventDefault()}>
      {extended && <StyledInput type="email" value={value} onChange={event => setValue(event.target.value)} placeholder="Subscribe to get email notifications" />}
      <Button buttonStyle="primary" className={buttonStyling} onClick={() => _horta("event", "open", {
      email: value,
      selectedDepartments
    })}>
        Subscribe to job alerts
      </Button>
    </StyledForm>;
}

require("../../../.linaria-cache/src/components/JobsForm/index.linaria.module.css");